import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Compass, MapPin, ExternalLink, X } from 'lucide-react';
import './TourViewer.css';

/**
 * Popup iframe viewer for a web-based virtual tour.
 * Renders into a portal; closes on overlay click or Escape.
 */
const TourViewer = ({ tour, onClose }) => {
  useEffect(() => {
    if (!tour) return undefined;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [tour, onClose]);

  if (!tour) return null;

  return ReactDOM.createPortal(
    <div className="tour-viewer-overlay" onClick={onClose}>
      <div className="tour-viewer" onClick={(e) => e.stopPropagation()}>
        <div className="tour-viewer__header">
          <div className="tour-viewer__title">
            <Compass size={18} />
            <div>
              <strong>{tour.title}</strong>
              {tour.location && (
                <span className="tour-viewer__sub"><MapPin size={12} /> {tour.location}</span>
              )}
            </div>
          </div>
          <div className="tour-viewer__actions">
            <a className="btn btn-secondary" href={tour.tourUrl} target="_blank" rel="noopener noreferrer">
              <ExternalLink size={15} /> Open in new tab
            </a>
            <button className="tour-viewer__close" title="Close" onClick={onClose}>
              <X size={18} />
            </button>
          </div>
        </div>
        <div className="tour-viewer__frame">
          <iframe
            title={tour.title}
            src={tour.tourUrl}
            allow="fullscreen; xr-spatial-tracking; accelerometer; gyroscope; magnetometer; vr"
            allowFullScreen
          />
          <p className="tour-viewer__fallback">
            Some tours block embedding. If the tour doesn't load,{' '}
            <a href={tour.tourUrl} target="_blank" rel="noopener noreferrer">open it in a new tab</a>.
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TourViewer;
